import { isFeatureEnabled } from 'owa-feature-flags';

export function addFlightInformationToConstraintsEnUs(constraints: Map<string, string>) {
    if (isFeatureEnabled('mc-smartCompose-exp-flight01')) {
        constraints.set('flight', '1');
    }
    if (isFeatureEnabled('mc-smartCompose-exp-flight02')) {
        constraints.set('flight', '2');
    }
    if (isFeatureEnabled('mc-smartCompose-exp-flight03')) {
        constraints.set('flight', '3');
    }
    if (isFeatureEnabled('mc-smartCompose-exp-flight04')) {
        constraints.set('flight', '4');
    }
    if (isFeatureEnabled('mc-smartCompose-exp-flight05')) {
        constraints.set('flight', '5');
    }
    if (isFeatureEnabled('mc-smartCompose-exp-flight06')) {
        constraints.set('flight', '6');
    }
    if (isFeatureEnabled('mc-smartCompose-exp-flight07')) {
        constraints.set('flight', '7');
    }
    if (isFeatureEnabled('mc-smartCompose-exp-flight08')) {
        constraints.set('flight', '8');
    }
    if (isFeatureEnabled('mc-smartCompose-exp-flight09')) {
        constraints.set('flight', '9');
    }
    if (isFeatureEnabled('mc-smartCompose-exp-flight10')) {
        constraints.set('flight', '10');
    }
}

export function addFlightInformationToConstraintsIntl(constraints: Map<string, string>) {
    if (isFeatureEnabled('mc-smartComposeIntl-exp-flight01')) {
        constraints.set('intl_flight', '1');
    }
    if (isFeatureEnabled('mc-smartComposeIntl-exp-flight02')) {
        constraints.set('intl_flight', '2');
    }
    if (isFeatureEnabled('mc-smartComposeIntl-exp-flight03')) {
        constraints.set('intl_flight', '3');
    }
    if (isFeatureEnabled('mc-smartComposeIntl-exp-flight04')) {
        constraints.set('intl_flight', '4');
    }
    if (isFeatureEnabled('mc-smartComposeIntl-exp-flight05')) {
        constraints.set('intl_flight', '5');
    }
}
